import { StaticBaseDao } from '@/dao';
import { PostResponse, AttachUnknownTagToContestantRequest } from '@/objects/generated';

export class UnknownTagDao extends StaticBaseDao {
    public static async ResyncUnknownTags(EventID: number, resyncAll: boolean): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `UnknownTag/ResyncUnknownTags` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (resyncAll == undefined ? '' : `resyncAll=${resyncAll}`),
            'POST',
        );
    }
    public static async AttachUnknownTagToContestant(
        EventID: number,
        attachUnknownTagToContestantRequest: AttachUnknownTagToContestantRequest,
    ): Promise<PostResponse | null> {
        return this.BaseFetch(
            PostResponse,
            `UnknownTag/AttachUnknownTagToContestant` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            attachUnknownTagToContestantRequest,
        );
    }
}
